module.exports = __webpack_public_path__ + "img/orange_lock.46ac7fda.png";